import callApi from '../../utils/call_apis';
import SellerFormValidation from '../../validations/SellerFormValidation'
import Grid from '@mui/material/Grid';
import React from "react";
import Snackbar from '../generals/Snackbar';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { userLogout } from '../../stores/AuthUserSlice';
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import authUtil from '../../utils/auth_util';
import { useNavigate } from "react-router-dom";
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react';


function SellerLogoutForm() {

    const navigate = useNavigate();
    
    useEffect(() => {
        // console.log('---useEffect--logout---');
        authUtil.deleteCredentials('auth-token')
        authUtil.deleteCredentials('session-payload')
        dispatch(userLogout())
        navigate('/seller/request-otp-to-login')
      }); 

    const [searchParams, setSearchParams] = useSearchParams()

    const initialValues = {
        'mob_number': searchParams.get('mob_number'),
        'otp': '',
    }
    const [reqPayload, setReqPayload] = React.useState(initialValues);
    const dispatch = useDispatch();


    const onSubmit = values => {
        // console.log('---onSubmit--values:', values);
        submitEmpLogin(values);
    }

    const formik = useFormik({
        initialValues,
        onSubmit,
        // validate,
        validationSchema: SellerFormValidation.sellerLoginSchema,
        validateOnChange: false
    })

    // console.log('---formik--values:', formik.values);
    // console.log('---formik--errors:', formik.errors);

    const successResponse = (response) => {
        // console.log('---successResponse--response:', response);
        authUtil.deleteCredentials('auth-token')
        authUtil.deleteCredentials('session-payload')
        dispatch(userLogout())
        dispatch(setSnackbar({
            status: 'success',
            message: response.data.message
        }))
        // navigate('/seller/request-otp-to-login')
    }

    const errorResponse = (error) => {
        formik.setErrors({ ...error.response.data.errors })
        // console.log('---errorResponse--formik--errors---221:', formik.errors);
        dispatch(setSnackbar({
            status: 'error',
            message: error.response.data.message
        }))
    }

    const submitEmpLogin = async (data, query = {}) => {
        try {
            const response = await callApi.requestGET(`/sellers-bids/seller/logout`, {}, true)
            
            // console.log('---submitEmpLogin---response:', response);
            successResponse(response)
        }
        catch (error) {
            // console.log('---submitEmpLogin---error:', error);
            errorResponse(error)
        }
    }


    return (
        <div>
            <Grid >


            </Grid>

            <Snackbar />
        </div>
    );

}


export { SellerLogoutForm };
